export default function setTimer(timer) {
    const url = `${process.env.REACT_APP_SERVER_IP}/exaustor/timer`;
    const data = {
        timer: timer
    };

    fetch(url, {
        method: 'POST', // Define o método como POST
        headers: {
            'Content-Type': 'application/json; charset=UTF-8' // Define o tipo de conteúdo
        },
        body: JSON.stringify(data) // Envia o data como JSON no corpo da requisição
    })
    .then(response => response.json())
    .then(data => {
        console.log(data); // Exibe a resposta no console
    })
    .catch(error => {
        console.error('Erro na requisição HTTP POST:', error);
    });
};
